export const RESELLER_SUBSCRIPTION_TICKET_SUBJECT =
  "Reseller Subscription Plan Request";

export function buildNewTicketUrl({ subject } = {}) {
  const params = new URLSearchParams({ action: "new" });

  if (subject) {
    params.set("subject", subject);
  }

  return `/tickets?${params.toString()}`;
}

export const RESELLER_SUBSCRIPTION_TICKET_URL = buildNewTicketUrl({
  subject: RESELLER_SUBSCRIPTION_TICKET_SUBJECT,
});
